
import { useEffect, useRef } from 'react';

import bazeleImage from '../imagesHome/bazeleconta.png';
import financiaraImage from '../imagesHome/contafinanciara.png';
import primaraImage from '../imagesHome/contaprimara.png';
import aplicataImage from '../imagesHome/contabilitateaplicata.png';

import './CourseBar.css';

const courses = [
  {
    id: 'bazele',
    image: bazeleImage,
    title: 'Bazele contabilitatii'
  },
  {
    id: 'financiara',
    image: financiaraImage,
    title: 'Contabilitate financiara'
  },
  {
    id: 'primara',
    image: primaraImage,
    title: 'Contabilitate primara'
  },
  {
    id: 'aplicata',
    image: aplicataImage,
    title: 'Contabilitate aplicata'
  }
];

export default function CourseBar() {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const updateDistance = () => {
      const firstGroup = track.children[0];

      if (firstGroup) {
        const distance =
          firstGroup.getBoundingClientRect().width;

        track.style.setProperty(
          '--scroll-distance',
          `${distance}px`
        );
      }
    };

    updateDistance();

    const observer = new ResizeObserver(updateDistance);
    observer.observe(track.children[0]);

    return () => observer.disconnect();
  }, []);

  const selectCourse = (courseId) => {
    window.dispatchEvent(
      new CustomEvent('contalearn:select-course', {
        detail: { courseId }
      })
    );

    document
      .getElementById('choose-your-course')
      ?.scrollIntoView({
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'instant'
          : 'smooth',
        block: 'center'
      });
  };

  return (
    <section
      className="cl-coursebar"
      aria-label="Exploreaza cursurile ContaLearn"
    >
      <div className="cl-coursebar__viewport">
        <div
          className="cl-coursebar__track"
          ref={trackRef}
        >
          {[0, 1, 2].map(group => (
            <div
              className="cl-coursebar__group"
              key={group}
              aria-hidden={group !== 0 ? 'true' : undefined}
              inert={group !== 0}
            >
              {courses.map(course => (
                <button
                  key={`${group}-${course.id}`}
                  type="button"
                  className="cl-coursebar__item"
                  onClick={() => selectCourse(course.id)}
                >
                  <img
                    src={course.image}
                    alt=""
                    className="cl-coursebar__image"
                    draggable="false"
                  />

                  <span className="cl-coursebar__name">
                    {course.title}
                  </span>
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
